import { LoggingRepository } from '@services/repositories/logging.repository'

interface LogFrontendEventParams {
	description: string
	action: string
	id: string
	username?: string
	step: string
	httpStatusCode?: string | number
	payload?: unknown
	entity?: string
}

const loggingRepository = new LoggingRepository()

const serializePayload = (payload?: unknown): string => {
	if (payload === undefined || payload === null) return ''
	if (typeof payload === 'string') return payload

	try {
		return JSON.stringify(payload)
	} catch {
		return String(payload)
	}
}

export const logFrontendEvent = ({
	description,
	action,
	id,
	username = '',
	step,
	httpStatusCode = '',
	payload = '',
	entity = 'log'
}: LogFrontendEventParams): void => {
	void loggingRepository
		.postLog({
			detail: {
				Description: description,
				Entity: entity,
				Action: action,
				Id: id,
				Username: username,
				Step: step,
				HTTPStatusCode: String(httpStatusCode)
			},
			payload: serializePayload(payload)
		})
		.catch(() => undefined)
}
